<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Li4A7K/tc-custom/9781460343555.jpg?1728726326328" alt="This image is the cover for the book Magnate's Manifesto"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Magnate's Manifesto
      </h1>
      <p class="bookDescription body article font2">
        <i><b>BILLIONAIRE PLAYBOY IGNITES INTERNATIONAL INCIDENT WITH HIS MANIFESTO ON WOMEN</b></i><i><b> </b></i><br/><br/><b>Jared Stone:</b> Visionary, rebel, the tech world's golden boyand now the most hated man on the planet! <br/><br/><b>Bailey St. James:</b> Survivor, powerful female executive, the only woman who refuses to bow down to Jared Stoneand the only woman who can save him? <br/><br/>When Jared's manifesto makes him public enemy #1 the only way out is to make Bailey an offer she can't refusea very public promotion to VP! Now, with a major deal on the line and tensions rising, can it be long before Jared and Bailey move from spreadsheets to bed sheets?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Hayward
      </h2>
      
      <p class="authorDescription body article">Award-winning author JENNIFER HAYWARD emerged on the publishing scene as the winner of Harlequin&#39;s So You Think You Can Write global writing contest. The recpient of Romantic Times Magazine&#39;s Reviewer&#39;s Choice Award for Best Harlequin Presents of 2014 Jennifer&#39;s careers in journalism and PR, including years of working alongside powerful, charismatic CEOs and traveling the world, have provided perfect fodder for the fast-paced, sexy stories she likes to write.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0af8004e